/*
 * @Author: Chao Yang
 * @Date: 2019-12-13 06:45:32
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-10-28 12:39:49
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Document from 'src/app/domain/model/document';
import { BaseProxy } from '../base.proxy';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';
import { format } from 'date-fns';

@Injectable()
export class FolderProxy extends BaseProxy {
  getFoldersWithEffectiveDate(
    fundIds: number[],
    accountIds: number[],
    folderId: number,
    effectiveDateFrom: Date,
    effectiveDateTo: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IFolder[]> {
    return this._http.post<Document.IFolder[]>(
      '/ip/api/folder/' +
      folderId +
      '?effectiveDateFrom=' +
      this.getDateStr(effectiveDateFrom) +
      '&effectiveDateTo=' +
      this.getDateStr(effectiveDateTo),
      {
        accountIds,
        fundIds,
        accounts,
      }
    );
  }

  getFoldersWithPostedDate(
    fundIds: number[],
    accountIds: number[],
    folderId: number,
    postedDateFrom: Date,
    postedDateTo: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IFolder[]> {
    return this._http.post<Document.IFolder[]>(
      '/ip/api/folder/' +
      folderId +
      '?postDateFrom=' +
      this.getDateStr(postedDateFrom) +
      '&postDateTo=' +
      this.getDateStr(postedDateTo) +
      '&clientTimeOffset=' +
      (new Date().getTimezoneOffset()),
      {
        accountIds,
        fundIds,
        accounts,
      }
    );
  }

  getTaxFolders(
    fundIds: number[],
    accountIds: number[],
    from: Date,
    to: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IFolder[]> {
    return this._http.post<Document.IFolder[]>(
      '/ip/api/folder/tax' +
      '?from=' +
      this.getDateStr(from) +
      '&to=' +
      this.getDateStr(to),
      {
        accountIds,
        fundIds,
        accounts,
      }
    );
  }
}
